/**
 * @generated SignedSource<<8f9d5044caa5fac4c9ab4a81b5ee498c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type UnmappedSlackUserReportTableRowFragment$data = {
  readonly organizationMembership: {
    readonly email: string | null;
    readonly member: {
      readonly " $fragmentSpreads": FragmentRefs<"ProfileAvatarWithDetailsFragment">;
    };
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"SlackUserProfileDropdownFragment">;
  readonly " $fragmentType": "UnmappedSlackUserReportTableRowFragment";
};
export type UnmappedSlackUserReportTableRowFragment$key = {
  readonly " $data"?: UnmappedSlackUserReportTableRowFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"UnmappedSlackUserReportTableRowFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "UnmappedSlackUserReportTableRowFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "OrganizationMembership",
      "kind": "LinkedField",
      "name": "organizationMembership",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "User",
          "kind": "LinkedField",
          "name": "member",
          "plural": false,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "ProfileAvatarWithDetailsFragment"
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "email",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SlackUserProfileDropdownFragment"
    }
  ],
  "type": "SlackUserImportMember",
  "abstractKey": null
};

(node as any).hash = "9cc9ed5c550d148077fb2d454c3107af";

export default node;
